const NoReport = () => (
  <div className='row'>
    <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
      There are no available reports to view at this time.
    </div>
  </div>
);

export default NoReport;